import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  // factoryCoo: [],
  factory: [],
  qasLastUser: 0,
  qasFolder: '',
  qasHasMapping: 'N',
  // qasBrand: [],
  qasVendor: [],
  qasQARegion: [],
  qasCountryPQA: [],
  qasAuditStage: [],
  qasAuditStatus: [],
  qasAuditorName: [],
  qasDefects: {},
  qasAuditPoint: [],
  qasUserAuditPoint: [],
  searchCriteria: {
    poDpo: null,
    factoryCoo: null,
    factory: null,
    brand: null,
    qaRegion: null,
    countryPqa: null,
    auditStage: null,
    auditStatus: null,
    auditorName: null,
    auditNum: null,
    auditType: null
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/qas/common/store/index.js